/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-loader[_ngcontent-%COMP%] {\r\n    height: 100%;\r\n    width:100%;\r\n    display: block;\r\n    position: absolute;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    background: rgba(255,255, 255, 0.5) ;\r\n    z-index: 555;\r\n}"];
export { styles as styles };
